var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ae2a88bf-8ae3-46b3-9516-43d404a0d94e",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329.88 387.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-7716d722-d888-48dc-8385-e93349d982c8 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-4428b65b-9e24-4491-9af7-7ed76779601a",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-6a13bb66-7256-4da1-8388-fc0c87c75ccf",
    "data-name": "09-Reports"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-7716d722-d888-48dc-8385-e93349d982c8",
    d: "M257.6,387.66H35.7c-5.54,0-10.76-2.16-14.68-6.08l-14.95-14.95c-3.92-3.92-6.08-9.13-6.08-14.68V72.28c0-5.54,2.16-10.75,6.08-14.67l14.95-14.95c3.92-3.92,9.13-6.08,14.68-6.08h141.16v24H37.05l-13.05,13.05v276.99l13.05,13.05h219.21l13.04-13.05v-197.25h24v198.6c0,5.54-2.16,10.76-6.08,14.68l-14.95,14.95c-3.92,3.92-9.13,6.08-14.68,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7716d722-d888-48dc-8385-e93349d982c8",
    d: "M294.18,351.08h-12.87v-24h11.53l13.05-13.05V37.05l-13.05-13.05H73.62l-13.05,13.05v11.53h-24v-12.87c0-5.54,2.16-10.75,6.08-14.67l14.95-14.95c3.92-3.92,9.13-6.08,14.68-6.08h221.9c5.54,0,10.76,2.16,14.68,6.08l14.95,14.95c3.92,3.92,6.08,9.13,6.08,14.68v279.68c0,5.54-2.16,10.76-6.08,14.68l-14.95,14.95c-3.92,3.92-9.13,6.08-14.68,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7716d722-d888-48dc-8385-e93349d982c8",
    d: "M281.3,165.36h-84.36c-17.69,0-32.08-14.39-32.08-32.08V48.58h24v84.71c0,4.45,3.62,8.08,8.08,8.08h84.36v24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7716d722-d888-48dc-8385-e93349d982c8",
    d: "M281.3,167.37c-3.08,0-6.16-1.18-8.5-3.53l-106.43-106.79c-4.68-4.69-4.67-12.29.03-16.97,4.69-4.68,12.29-4.67,16.97.03l106.43,106.79c4.68,4.69,4.67,12.29-.03,16.97-2.34,2.33-5.41,3.5-8.47,3.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-7716d722-d888-48dc-8385-e93349d982c8",
    x: 66.78,
    y: 261.2,
    width: 31.95,
    height: 88.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-7716d722-d888-48dc-8385-e93349d982c8",
    x: 130.68,
    y: 210.89,
    width: 31.95,
    height: 138.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-7716d722-d888-48dc-8385-e93349d982c8",
    x: 194.58,
    y: 182.34,
    width: 31.95,
    height: 167.23
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsLight);
export default __webpack_public_path__ + "static/media/ReportsLight.f2cacde6937316d64fe3c4d662e2e575.svg";
export { ForwardRef as ReactComponent };